/* src/app/navigation/components/wg-sidebar/wg-sidebar.component.css */
:host {
  display: block;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #334155;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
:host a,
:host button {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
}
:host h1,
:host p,
:host div,
:host nav,
:host aside {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: inherit;
  font-family: inherit;
  font-weight: normal;
  font-style: normal;
  line-height: inherit;
  text-transform: none;
  letter-spacing: normal;
  color: inherit;
  text-decoration: none;
  box-sizing: border-box;
}
:host h1,
:host p {
  display: block;
}
:host nav {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
:host nav:hover {
  scrollbar-color: rgba(0, 0, 0, 0.12) transparent;
}
/*# sourceMappingURL=wg-sidebar.component.css.map */
